module.exports = __webpack_public_path__ + "media/images/cart-f7984a88.svg";